import React from 'react';

const tones = {
  actual: 'bg-gray-100 text-gray-600',
  mixed: 'bg-orange-50 text-orange-700',
  forecast: 'bg-blue-50 text-blue-700',
  paid: 'bg-emerald-50 text-emerald-800',
  scheduled: 'bg-orange-50 text-orange-700',
  success: 'bg-emerald-50 text-emerald-800',
  warning: 'bg-orange-50 text-orange-700',
  critical: 'bg-red-50 text-red-700',
  info: 'bg-blue-50 text-blue-700',
  neutral: 'bg-gray-100 text-gray-600',
};

export default function Chip({ children, tone = 'neutral' }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-sm px-2 py-0.5 text-[11px] font-medium leading-none tracking-wide ${tones[tone] || tones.neutral}`}
    >
      <span
        className="h-1.5 w-1.5 rounded-full bg-current opacity-70"
        aria-hidden="true"
      />
      {children}
    </span>
  );
}
